import { createReducer, on } from '@ngrx/store';

import * as userActions from '../actions/user.action';
import * as fromState from '../states/user.state';

export const usersFeatureKey = 'users';

export const reducer = createReducer(
  fromState.initialState,
  on(userActions.setCurrentUser, (state, { user }) => {
    return {
      ...state,
      currentUser: user,
      isAuthenticated: user !== null,
      errorText: null
    };
  }),
  on(userActions.loginUserSuccess, (state, { user }) => {
    return {
      ...state,
      currentUser: user,
      isAuthenticated: true,
      errorText: null
    };
  }),
  on(userActions.loginUserError, (state, { error }) => {
    return {
      ...state,
      currentUser: null,
      errorText: error || 'Login failed',
      isAuthenticated: false
    };
  }),
  on(userActions.logoutUserSuccess, state => {
    return {
      ...state,
      currentUser: null,
      isAuthenticated: false,
      errorText: null
    };
  }),
  on(userActions.switchTenantSuccess, (state, { user }) => {
    return {
      ...state,
      currentUser: user,
    };
  }),
  on(userActions.switchTenantBackSuccess, (state, { user }) => {
    return {
      ...state,
      currentUser: user
    };
  }),
  on(userActions.updateUser, (state, { user }) => {
    return {
      ...state,
      currentUser: user
    };
  }),
  on(userActions.changeOrgUnitSuccess, (state, { user }) => {
    return {
      ...state,
      currentUser: user,
    };
  })
);
